export const WHITE = '#FFFFFF';
export const GREY_ONE = '#FAFBFD';
export const GREY_THREE = '#E6E6E6';
export const GREY_FOUR = '#D2D2D2';
export const GREY_LIGHT = '#E4E5EB';
export const GREY_MEDIUM = '#4D4D4D';
export const GREY_DARK = '#4C5165';
export const PURPLE_MAIN = '#24007E';
export const PURPLE_FIGURE = '#42368E';
export const BLURPLE_LIGHT = '#F3F4F9';
export const BLURPLE_MOODY = '#190050';
export const BLACK = '#000000';
export const BLACK_SOUL = '#2D2D2D';
export const YELLOW_MELLOW = '#FEC82A';
export const DARK_BLURPLE = '#290D6D';

export const MARKETS_GREEN = '#6abd45';
export const MARKETS_RED = '#e92829';
